import { getDiff } from './util.get-diff.js';
import { normalizeTextInput } from './util.normalize-input.js';

function getStatusForAllWords(args) {
  // Start by finding differences between the initial text and the correct
  // answer (all added and changed words needs to count as a point)
  const inconsistentWords = [];
  getDiff(normalizeTextInput(args.initialInput), normalizeTextInput(args.correctAnswer)).forEach(word => {
    // Skip words that should be removed (we'll automatically validate
    // those when validating the current input against the correct
    // answer - if they haven't been removed, it will be detected)
    if (word.removed) {
      return;
    }

    // Register that words that were modified or added in the correct
    // answer are essential to the validation
    inconsistentWords.push(!!(word.added || word.modified));
  });

  // Now compare the current input with the correct answer and determine
  // status for each word
  let wordIndex = -1;
  const result = getDiff(normalizeTextInput(args.correctAnswer), normalizeTextInput(args.userInput)).map(word => {
    // If the word was added, then mark it as essential and wrong (as
    // it's an inconsistency between the current input and the correct
    // answer)
    if (word.added) {
      return {
        text: word.value,
        essential: true,
        correct: false,
        state: "added"
      };
    }

    // Update word-index in relation to the correct answer
    wordIndex++;

    // If the word has been modified or removed, then mark it as
    // essential and wrong (as it's an inconsistency between the current
    // input and the correct answer)
    if (word.modified || word.removed) {
      return {
        text: word.value,
        essential: true,
        correct: false,
        state: inconsistentWords[wordIndex] ? "neutral" : word.modified ? "modified" : "removed"
      };
    }

    // ... Otherwise the word is neutral as compared with the correct
    // answer (a neutral word can be considered essential if it was
    // inconsistent between the initial text and the correct answer)
    return {
      text: word.value,
      essential: inconsistentWords[wordIndex],
      correct: true,
      state: "neutral"
    };
  });

  // Now re-embed information about linebreaks into the resultset
  let linebreakAt = 0;
  args.userInput.split("\n").slice(0, -1).forEach(text => {
    text = normalizeTextInput(text);

    // Calculate number of words to offset by
    if (text.length) {
      linebreakAt += text.split(" ").length;
    }

    // Loop through and find to index of the word after which we should
    // inject the
    wordIndex = 0;
    let resultIndex = result.length;
    for (let i = -1, j = result.length; ++i < j;) {
      if (result[i]?.state !== "removed" && result[i]?.state !== "linebreak") {
        wordIndex++;
      }
      if (wordIndex === linebreakAt) {
        resultIndex = i + 1;
        break;
      }
    }
    result.splice(resultIndex, 0, {
      state: "linebreak"
    });
  });
  return result;
}

export { getStatusForAllWords };
//# sourceMappingURL=util.get-status-for-words.js.map
